<template>
  <div>
    <div class="top">
      <img src="../../assets/合作伙伴banner.png"
           alt="">
    </div>
    <div class="box">
      <div class="text">部分合作机构</div>
      <div class="p"></div>
      <div class="hospital">
        <div v-for="(item,index) in tableDat"
             :key="index">
          <img style="width:100%;height:100%;"
               :src="item.fileLocal+item.fileUrl"
               alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      tableDat: []
    }
  },
  created () {
    this.api.Maintenance({ t: { classify: '合作伙伴' }, p: {} }).then((res) => {
      console.log(res)
      this.tableDat = res.data.rows
    })
  },
}
</script>

<style lang="less" scoped>
@media (min-width: 1024px) {
  .top {
    height: 100%;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .box {
    display: table;
    border-collapse: collapse;
    margin: 0 auto;
    width: 1200px;
    // border: 1px solid;
    .text {
      margin-left: 10px;
      margin-top: 50px;
      width: 300px;
      height: 80px;
      // border: 1px solid;
      font-size: 36px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #3d3d3d;
    }
    .p {
      width: 1180px;
      margin: auto;
      border-bottom: 1px solid #367dffff;
    }
    .hospital {
      margin-top: 50px;
      // border: 1px solid;
      width: 1200px;
      // height: 300px;
      margin-bottom: 80px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: flex-start;
      // justify-content: space-between;
      div {
        width: 215px;
        height: 126px;
        margin-left: 12.5px;
        margin-right: 12.5px;
        border-radius: 20px;
        // border: 0.5px solid #2D2D2DFF;
        box-shadow: 1px 0px 4px 1px rgba(0, 0, 0, 0.1);
        margin-bottom: 25px;
      }
    }
  }
}
@media (max-width: 1024px) {
  .top {
    height: 100%;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .box {
    display: table;
    border-collapse: collapse;
    margin: 0 auto;
    width: 330px;
    // border: 1px solid;
    .text {
      margin: 0, auto;
      margin-top: 30px;
      width: 330px;
      height: 60px;
      // border: 1px solid;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #3d3d3d;
    }
    .p {
      width: 100%;
      margin: auto;
      border-bottom: 1px solid #367dffff;
    }
    .hospital {
      margin-top: 30px;
      // border: 1px solid;
      width: 330px;
      // height: 300px;
      margin-bottom: 30px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: space-between;
      div {
        width: 158px;
        height: 76px;
        // margin-left: 10px;
        // margin-right: 10px;
        border-radius: 15px;
        // border: 0.5px solid #2D2D2DFF;
        box-shadow: 1px 0px 2px 1px rgba(0, 0, 0, 0.1);
        margin-bottom: 15px;
      }
    }
  }
}
</style>